import getPayeService from '../../../api/envService'
import { VARIABLE_CLIENT_ENDPOINT } from '../../../api/endpoints'
import { setLoader } from '../loader-action'
import { SET_VARIABLE_CLIENTS } from '../../reducers/fonction/variable-client-reducer'

export const setVariableClients = models => {
  return { type: SET_VARIABLE_CLIENTS, value: models }
}

export const getVariableClients = () => dispatch =>
  Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().get(VARIABLE_CLIENT_ENDPOINT))
    .then(models => dispatch(setVariableClients(models)))
    .finally(() => dispatch(setLoader()))

export const createVariableClient = variableClient => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().post(VARIABLE_CLIENT_ENDPOINT, variableClient))
    .then(() => dispatch(getVariableClients()))
    .catch(e => {
      console.log(e)
    })

export const updateVariableClient = variableClient => dispatch =>
  Promise.resolve()
    .then(() => getPayeService().put(VARIABLE_CLIENT_ENDPOINT, variableClient))
    .then(() => dispatch(getVariableClients()))
    .catch(e => {
      console.log(e)
    })

export const deleteVariableClient = nom => dispatch => {
  return Promise.resolve()
    .then(() => dispatch(setLoader(true)))
    .then(() => getPayeService().deleteById(VARIABLE_CLIENT_ENDPOINT, nom))
    .then(() => dispatch(getVariableClients()))
    .finally(() => dispatch(setLoader(false)))
}
